import * as React from 'react';

export interface IErrorProps {
    errorText: string;      
    onDismiss: () => void;
}

export class SearchError extends React.Component<IErrorProps, any> {
    render() {
        return (
            <div className="adage-search-alert adage-search-alert-error" role="dialog">
                <div className="adage-search-alert-content">
                    <div className="adage-search-alert-content-text" dangerouslySetInnerHTML={{ __html: this.props.errorText }} />
                </div>

                <button className="adage-search-alert-close" onClick={this.props.onDismiss}>
                    Dismiss
                </button>
            </div>
        );
    }
}